var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 162,
    viewBox: "0 0 161 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_141_11054)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_11054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.211 66.5125C113.211 60.2467 111.561 54.0915 108.428 48.6653C105.295 43.2391 100.789 38.7332 95.3622 35.6004C89.9358 32.4676 83.7804 30.8184 77.5147 30.8184C71.2489 30.8184 65.0935 32.4676 59.6672 35.6004C54.2408 38.7331 49.7346 43.239 46.6015 48.6652C43.4684 54.0914 41.8188 60.2466 41.8184 66.5124C41.818 72.7782 43.4668 78.9336 46.5993 84.3602C49.7317 89.7868 54.2373 94.2932 59.6633 97.4267L77.5114 66.5125H113.211Z",
    fill: "#FC868B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7461 81.4664C50.2657 87.1365 53.1601 92.3443 57.1731 96.6286C61.1861 100.913 66.1937 104.141 71.7524 106.028C77.3111 107.915 83.2493 108.402 89.0411 107.445C94.8328 106.489 100.299 104.119 104.956 100.545C109.614 96.9719 113.317 92.3049 115.74 86.958C118.163 81.611 119.229 75.7492 118.846 69.8915C118.462 64.0339 116.639 58.3614 113.539 53.3764C110.44 48.3913 106.158 44.2477 101.075 41.3125L83.2264 72.2267L48.7461 81.4664Z",
    fill: "#2EBCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5115 102.209C97.2278 102.209 113.209 86.2262 113.209 66.5115C113.209 58.1103 110.307 50.3854 105.447 44.2877C99.1359 39.2518 91.298 36.5149 83.2236 36.5274C63.5089 36.5274 47.5273 52.509 47.5273 72.2237C47.5273 80.6249 50.43 88.3514 55.2876 94.4475C61.5989 99.4839 69.4369 102.221 77.5115 102.209Z",
    fill: "#2D6388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6074 40.9416C53.6451 39.9296 54.7439 38.9818 55.9004 38.1016C56.2651 38.1915 56.6153 38.3602 56.9269 38.6092L82.9048 59.4034C85.8283 61.7422 86.0307 66.1372 83.3819 68.7844C80.733 71.4301 76.3348 71.2277 73.9927 68.3073L53.1793 42.352C52.855 41.9478 52.6562 41.4575 52.6074 40.9416Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_141_11054",
    x: 0.0521603,
    y: 0.52608,
    width: 160.635,
    height: 160.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.4739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_11054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_11054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_11054"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.9aaf2fb0070c26078a15eae451a4e2da.svg";
export { ForwardRef as ReactComponent };